import { Routes } from "@angular/router";
import { FindPasswordComponent } from "./find-password/find-password.component";
import { LoginComponent } from "./login/login.component";
import { BenefitBoardComponent } from "./member/benefit-board/benefit-board.component";
import { BenefitDetailComponent } from "./member/benefit-board/benefit-detail/benefit-detail.component";
import { BillBoardComponent } from "./member/bill-board/bill-board.component";
import { CommunityBoardComponent } from "./member/community-board/community-board.component";
import { CommunityDetailComponent } from "./member/community-board/community-detail/community-detail.component";
import { CreditBoardComponent } from "./member/credit-board/credit-board.component";
import { GuestComponent } from "./member/guest/guest.component";
import { GuideDetailComponent } from "./member/guide/guide-detail/guide-detail.component";
import { GuideComponent } from "./member/guide/guide.component";
import { HelpBoardComponent } from "./member/help-board/help-board.component";
import { HelpDetailComponent } from "./member/help-board/help-detail/help-detail.component";
/* Member */
import { MemberHomeComponent } from "./member/home/home.component";
import { ManagementComponent } from "./member/management/management.component";
import { MemberBoardComponent } from "./member/member-board/member-board.component";
import { MemberDetailComponent } from "./member/member-board/member-detail/member-detail.component";
import { MemberComponent } from "./member/member.component";
import { MyinfoEditComponent } from "./member/myinfo-edit/myinfo-edit.component";
import { MypageComponent } from "./member/mypage/mypage.component";
import { PrintingBoardComponent } from "./member/printing-board/printing-board.component";
import { RentalComponent } from "./member/rental/rental.component";
import { ReservationListComponent } from "./member/reservation/list/list.component";
import { ReservationComponent } from "./member/reservation/reservation.component";
import { Page404Component } from "./page-404/page-404.component";
import { Page500Component } from "./page-500/page-500.component";
import { Page502Component } from "./page-502/page-502.component";
import { PrivacyComponent } from "./privacy/privacy.component";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
/* Space by location */
import { MyinfoCanDeactivate } from "./service/member/myinfo-can-deactivate.service";
import { RedirectComponent } from "./shared/redirect/redirect.component";
// 정리
import { ApplicationGuard } from "./application.guard";
import { HomeComponent } from "./home/home.component";
import { SignUpComponent } from "./signup/signup.component";
import { TermsComponent } from "./terms/terms.component";

export const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
    canActivate: [ApplicationGuard],
  },
  {
    path: "redirect/:url",
    component: RedirectComponent,
  },
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "reset-password",
    component: ResetPasswordComponent,
  },
  {
    path: "find-password",
    component: FindPasswordComponent,
  },
  {
    path: "terms",
    component: TermsComponent,
  },
  {
    path: "privacy",
    component: PrivacyComponent,
  },
  {
    path: "member",
    component: MemberComponent,
    children: [
      {
        path: "home",
        component: MemberHomeComponent,
      },
      {
        path: "hey",
        redirectTo: "member/community",
      },
      {
        path: "hey/new",
        redirectTo: "member/community",
      },
      {
        path: "hey/:id",
        redirectTo: "member/community",
      },
      {
        path: "hey/:id/edit",
        redirectTo: "member/community",
      },
      {
        path: "community",
        component: CommunityBoardComponent,
      },
      {
        path: "community/new",
        component: CommunityDetailComponent,
      },
      {
        path: "community/:id",
        component: CommunityDetailComponent,
      },
      {
        path: "reservation",
        redirectTo: "reservation/rooms",
      },
      {
        path: "reservation/:category",
        component: ReservationComponent,
      },
      {
        path: "reservation/:category/list/:date",
        component: ReservationListComponent,
      },
      {
        path: "rental",
        redirectTo: "rental/seongsu/1",
      },
      {
        path: "rental/:category",
        redirectTo: "rental/:category/1",
      },
      {
        path: "rental/:category/:groupIndex",
        component: RentalComponent,
      },
      {
        path: "search",
        component: MemberBoardComponent,
      },
      {
        path: "search/new",
        component: MemberDetailComponent,
      },
      {
        path: "search/:id",
        component: MemberDetailComponent,
      },
      {
        path: "help",
        component: HelpBoardComponent,
      },
      {
        path: "help/:id",
        component: HelpDetailComponent,
      },
      {
        path: "notice",
        component: HelpBoardComponent,
      },
      {
        path: "notice/:id",
        component: HelpDetailComponent,
      },
      {
        path: "mypage",
        redirectTo: "mypage/community",
      },
      {
        path: "mypage/hey",
        redirectTo: "mypage/community",
      },
      {
        path: "mypage/hey/:id",
        redirectTo: "mypage/community",
      },
      {
        path: "mypage/help",
        redirectTo: "mypage/community",
      },
      {
        path: "mypage/help/:id",
        redirectTo: "mypage/community",
      },
      {
        path: "mypage/:category/:id",
        redirectTo: "community/:id",
      },
      {
        path: "mypage/:category",
        component: MypageComponent,
      },
      {
        path: "myinfo-edit",
        canDeactivate: [MyinfoCanDeactivate],
        component: MyinfoEditComponent,
      },
      {
        path: "credit",
        component: CreditBoardComponent,
      },
      {
        path: "print",
        component: PrintingBoardComponent,
      },
      {
        path: "bill",
        component: BillBoardComponent,
      },
      //____________________________________
      {
        path: "guide",
        component: GuideComponent,
      },
      {
        path: "guide/:id",
        component: GuideDetailComponent,
      },
      {
        path: "benefit",
        component: BenefitBoardComponent,
      },
      {
        path: "benefit/:id",
        component: BenefitDetailComponent,
      },
      //____________________________________
      {
        path: "guest",
        component: GuestComponent,
      },
      {
        path: "guest/:id",
        component: GuestComponent,
      },
      {
        path: "management",
        component: ManagementComponent,
      },
      {
        path: "**",
        redirectTo: "member/community",
      },
    ],
  },

  // new ________________________________________
  // {
  //   path: "heyground",
  //   component: HeygroundComponent,
  //   canActivate: [ApplicationGuard],
  //   children: [
  //     {
  //       path: "about",
  //       component: AboutComponent,
  //     },
  //     {
  //       path: "location",
  //       component: LocationComponent,
  //     },
  //     {
  //       path: "partners",
  //       redirectTo: "partners/",
  //     },
  //     {
  //       path: "partners/:category",
  //       component: PartnersComponent,
  //     },
  //     {
  //       path: "**",
  //       redirectTo: "about",
  //     },
  //   ],
  // },
  // {
  //   path: "seongsu",
  //   component: SeongsuComponent,
  //   canActivate: [ApplicationGuard],
  //   children: [
  //     {
  //       path: "space",
  //       component: SeongsuSpaceComponent,
  //     },
  //     {
  //       path: "plan",
  //       component: PlanComponent,
  //     },
  //     // {
  //     //   path: "tour",
  //     //   component: TourComponent,
  //     // },
  //     {
  //       path: "members",
  //       component: SpaceMembersComponent,
  //     },
  //     {
  //       path: "faq",
  //       redirectTo: "faq/all",
  //     },
  //     {
  //       path: "faq/:category",
  //       component: FaqComponent,
  //     },
  //     {
  //       path: "**",
  //       redirectTo: "space",
  //     },
  //   ],
  // },
  // {
  //   path: "seoulsoop",
  //   component: SeoulsoopComponent,
  //   canActivate: [ApplicationGuard],
  //   children: [
  //     {
  //       path: "space",
  //       component: SeoulsoopSpaceComponent,
  //     },
  //     {
  //       path: "plan",
  //       component: PlanComponent,
  //     },
  //     // {
  //     //   path: "tour",
  //     //   component: TourComponent,
  //     // },
  //     {
  //       path: "members",
  //       component: SpaceMembersComponent,
  //     },
  //     {
  //       path: "faq",
  //       redirectTo: "faq/all",
  //     },
  //     {
  //       path: "faq/:category",
  //       component: FaqComponent,
  //     },
  //     {
  //       path: "**",
  //       redirectTo: "space",
  //     },
  //   ],
  // },
  // {
  //   path: "tour",
  //   canActivate: [ApplicationGuard],
  //   children: [
  //     {
  //       path: "lookup",
  //       component: TourLookupComponent,
  //     },
  //     {
  //       path: "list",
  //       component: TourListComponent,
  //     },
  //     {
  //       path: ":id",
  //       component: TourDetailComponent,
  //     },
  //     {
  //       path: "**",
  //       redirectTo: "lookup",
  //     },
  //   ],
  // },
  // {
  //   path: "space/:id",
  //   component: SpaceMemberDetailComponent,
  //   canActivate: [ApplicationGuard],
  // },
  // {
  //   path: "apply",
  //   component: ApplyComponent,
  //   canActivate: [ApplicationGuard],
  // },
  {
    path: "signup",
    component: SignUpComponent,
  },
  {
    path: "404",
    component: Page404Component,
  },
  {
    path: "500",
    component: Page500Component,
  },
  {
    path: "502",
    component: Page502Component,
  },
  {
    path: "**",
    redirectTo: "member/community",
  },
];



// WEBPACK FOOTER //
// ./src/app/app.route.ts